'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var locale$1 = require('../constants/locale.js');
var locale = require('../enums/locale.js');

const cjkLocales = new Set([
    locale.IsoLanguagesRegions.JA,
    locale.IsoLanguagesRegions.KO,
    locale.IsoLanguagesRegions.ZH,
    locale.IsoLanguagesRegions.ZH_CN,
    locale.IsoLanguagesRegions.ZH_TW
]);
/**
 * Convert a file size in bytes to a human-readable string.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 *
 * @param options LocalizeFileSizeOptions
 * @returns string
 */ const localizeFileSize = (options)=>{
    const { size  } = options;
    if (size === null || size === undefined || size < 0) return '';
    const isBytes = size < 1024;
    const { locale: locale$2 =locale$1.DEFAULT_ISO_LANGUAGE_REGION , numberFormatOptions ={
        notation: 'compact',
        style: 'unit',
        unit: 'byte',
        unitDisplay: isBytes ? 'short' : 'narrow' // matches existing Boulder for "bytes" instead of  "b"
    }  } = options;
    let consistentLocale = locale$2;
    if (cjkLocales.has(locale$2) && size > 1023) {
        // Chinese, Japanese, and Korean locales produce strings like 1327万B
        // which is not a common way to express file sizes in those languages.
        // Instead we want to prefer the international unit of KB/MB/GB which we'll
        // get from English.
        consistentLocale = locale.IsoLanguagesRegions.EN;
    }
    let formatted = new Intl.NumberFormat([
        consistentLocale
    ], numberFormatOptions).format(size);
    if (consistentLocale === locale.IsoLanguagesRegions.EN || consistentLocale === locale.IsoLanguagesRegions.EN_US) {
        // adds a space between the digit and a-z characters
        // eslint-disable-next-line unicorn/prefer-string-replace-all
        formatted = isBytes ? formatted : formatted.replace(/(\d)([A-Za-z])/g, '$1 $2');
        return formatted.endsWith('BB') ? formatted.replace('BB', 'GB') : size > 1 && formatted.endsWith('byte') ? formatted.replace('byte', 'bytes') : formatted;
    } else {
        return formatted;
    }
};

exports.localizeFileSize = localizeFileSize;
//# sourceMappingURL=size.js.map
